export type Theme = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'dhc-track-theme';

export function getStoredTheme(): Theme {
  const v = localStorage.getItem(STORAGE_KEY);
  // Default is dark — the DHC brand ground ("schwarz gelb").
  return v === 'light' || v === 'dark' || v === 'system' ? v : 'dark';
}

export function applyTheme(theme: Theme): void {
  const resolved =
    theme === 'system'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
      : theme;
  document.documentElement.setAttribute('data-theme', resolved);
}

export function setTheme(theme: Theme): void {
  localStorage.setItem(STORAGE_KEY, theme);
  applyTheme(theme);
}

export function initTheme(): void {
  const theme = getStoredTheme();
  applyTheme(theme);
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', () => {
      if (getStoredTheme() === 'system') applyTheme('system');
    });
}
